var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2Micropipette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 111,
    viewBox: "0 0 15 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71432 3.17383V11.4347H5.85718V3.17383H8.71432Z",
    fill: "#CB7569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71432 3.17383V4.04339H5.85718V3.17383H8.71432Z",
    fill: "#C05A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8286 3.17391L3.77144 3.17391C3.74287 3.17391 3.71429 3.17391 3.71429 3.12087V1.43478C3.71429 1.43478 3.71429 1 4.07144 1L10.5 1C10.7893 1 10.8464 1.33739 10.8554 1.41739C10.8567 1.42892 10.8573 1.44054 10.8571 1.45217V3.12087C10.8571 3.17391 10.8571 3.17391 10.8286 3.17391Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07141 2.08653C4.07141 2.02888 4.09022 1.97358 4.12371 1.93281C4.1572 1.89204 4.20262 1.86914 4.24998 1.86914C4.29734 1.86914 4.34276 1.89204 4.37625 1.93281C4.40974 1.97358 4.42855 2.02888 4.42855 2.08653V3.17349H4.07141V2.08653ZM5.49998 2.08653C5.49998 2.02888 5.5188 1.97358 5.55228 1.93281C5.58577 1.89204 5.63119 1.86914 5.67855 1.86914C5.72591 1.86914 5.77133 1.89204 5.80482 1.93281C5.83831 1.97358 5.85713 2.02888 5.85713 2.08653V3.17349H5.49998V2.08653ZM6.92855 2.08653C6.92855 2.02888 6.94737 1.97358 6.98086 1.93281C7.01434 1.89204 7.05977 1.86914 7.10713 1.86914C7.15449 1.86914 7.19991 1.89204 7.23339 1.93281C7.26688 1.97358 7.2857 2.02888 7.2857 2.08653V3.17349H6.92855V2.08653ZM8.35713 2.08653C8.35713 2.02888 8.37594 1.97358 8.40943 1.93281C8.44292 1.89204 8.48834 1.86914 8.5357 1.86914C8.58306 1.86914 8.62848 1.89204 8.66197 1.93281C8.69545 1.97358 8.71427 2.02888 8.71427 2.08653V3.17349H8.35713V2.08653ZM9.7857 2.08653C9.7857 2.02888 9.80451 1.97358 9.838 1.93281C9.87149 1.89204 9.91691 1.86914 9.96427 1.86914C10.0116 1.86914 10.057 1.89204 10.0905 1.93281C10.124 1.97358 10.1428 2.02888 10.1428 2.08653V3.17349H9.7857V2.08653ZM4.7857 2.08653C4.7857 2.02888 4.80451 1.97358 4.838 1.93281C4.87149 1.89204 4.91691 1.86914 4.96427 1.86914C5.01163 1.86914 5.05705 1.89204 5.09054 1.93281C5.12403 1.97358 5.14284 2.02888 5.14284 2.08653V3.17349H4.7857V2.08653ZM6.21427 2.08653C6.21427 2.02888 6.23308 1.97358 6.26657 1.93281C6.30006 1.89204 6.34548 1.86914 6.39284 1.86914C6.4402 1.86914 6.48562 1.89204 6.51911 1.93281C6.5526 1.97358 6.57141 2.02888 6.57141 2.08653V3.17349H6.21427V2.08653ZM7.64284 2.08653C7.64284 2.02888 7.66165 1.97358 7.69514 1.93281C7.72863 1.89204 7.77405 1.86914 7.82141 1.86914C7.86877 1.86914 7.91419 1.89204 7.94768 1.93281C7.98117 1.97358 7.99998 2.02888 7.99998 2.08653V3.17349H7.64284V2.08653ZM9.07141 2.08653C9.07141 2.02888 9.09022 1.97358 9.12371 1.93281C9.1572 1.89204 9.20262 1.86914 9.24998 1.86914C9.29734 1.86914 9.34276 1.89204 9.37625 1.93281C9.40974 1.97358 9.42855 2.02888 9.42855 2.08653V3.17349H9.07141V2.08653ZM10.5 2.08653C10.5 2.02888 10.5188 1.97358 10.5523 1.93281C10.5858 1.89204 10.6312 1.86914 10.6786 1.86914C10.7259 1.86914 10.7713 1.89204 10.8048 1.93281C10.8383 1.97358 10.8571 2.02888 10.8571 2.08653V3.17349H10.5V2.08653Z",
    fill: "#B84B3D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.20409 84.7702H6.38649C6.29083 84.7702 6.21429 84.6598 6.21429 84.5218L6.21429 81.292H8.35715V84.5218C8.35715 84.6598 8.28062 84.7702 8.20409 84.7702Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42859 54.3359H7.28573V73.9012H5.85716C5.85716 73.9012 5.65308 61.3794 4.42859 54.3359Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1429 54.3359H7.28574V73.9012H8.71431C8.71431 73.9012 8.91839 61.3794 10.1429 54.3359Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85718 56.1991C5.85718 55.4101 6.49677 54.7705 7.28575 54.7705V54.7705C8.07473 54.7705 8.71432 55.4101 8.71432 56.1991V81.6028C8.71432 82.3918 8.07473 83.0314 7.28575 83.0314V83.0314C6.49677 83.0314 5.85718 82.3918 5.85718 81.6028L5.85718 56.1991Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8572 47.3789H3.71429L3.71429 54.3354C3.71429 54.8157 5.31328 55.205 7.28572 55.205C9.25817 55.205 10.8572 54.8157 10.8572 54.3354V47.3789Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5704 48.6633L11.5704 13.0313C11.5704 12.4193 11.301 12.1212 10.8603 11.8589L9.29311 10.9265L7.3097 9.79004L5.10591 11.0722L3.73466 11.8589C3.26941 12.1212 3.00006 12.6457 3.00006 13.2576L3.00006 48.6834C3.00006 49.1637 4.91884 49.553 7.28578 49.553C9.65271 49.553 11.5715 49.1637 11.5715 48.6834C11.5715 48.6767 11.5711 48.67 11.5704 48.6633Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 9,
    width: 9,
    height: 41
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5704 48.6633L11.5704 13.0313C11.5704 12.4193 11.301 12.1212 10.8603 11.8589L9.29311 10.9265L7.3097 9.79004L5.10591 11.0722L3.73466 11.8589C3.26941 12.1212 3.00006 12.6457 3.00006 13.2576L3.00006 48.6834C3.00006 49.1637 4.91884 49.553 7.28578 49.553C9.65271 49.553 11.5715 49.1637 11.5715 48.6834C11.5715 48.6767 11.5711 48.67 11.5704 48.6633Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.00006,
    y: 11.7266,
    width: 2.14286,
    height: 37.8261,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.42865,
    y: 11.7266,
    width: 2.14286,
    height: 37.8261,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.30956 9.96513C8.22916 9.96513 8.97465 9.61288 8.97465 9.17836C8.97465 8.74385 8.22916 8.3916 7.30956 8.3916C6.38996 8.3916 5.64447 8.74385 5.64447 9.17836C5.64447 9.61288 6.38996 9.96513 7.30956 9.96513Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 10.431C9.95384 9.49855 9.19475 8.79921 8.33772 8.50781C8.16632 8.65351 7.77453 8.74093 7.2848 8.74093C6.81955 8.74093 6.45226 8.65351 6.25636 8.53695C5.39933 8.85748 4.61576 9.49855 4.12603 10.4601C3.95462 10.8098 3.88116 11.2469 3.88116 11.6549L3.88116 15.6469C3.88116 15.9675 4.12603 16.2006 4.39538 16.1714C5.20344 15.9966 6.15842 15.88 7.21134 15.88C8.33772 15.88 9.31719 15.9966 10.1742 16.1714C10.4436 16.2297 10.6884 15.9966 10.6884 15.6469V11.5966C10.6884 11.1886 10.615 10.7807 10.4436 10.431Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22552 11.1009C4.56834 10.5472 5.05807 10.1393 5.57229 9.81877C5.84164 9.67307 6.11099 9.55651 6.40483 9.4691C6.69867 9.38168 6.99251 9.35254 7.28635 9.35254C7.87403 9.35254 8.48619 9.49824 9.00041 9.81877C9.53911 10.1102 10.0044 10.5472 10.3472 11.1009C9.85744 10.7221 9.36771 10.4307 8.85349 10.2267C8.58414 10.1393 8.33927 10.0519 8.06992 9.9936C7.80057 9.93532 7.53121 9.90618 7.26186 9.90618C6.72316 9.90618 6.18445 10.0227 5.67023 10.1976C5.20499 10.4307 4.69077 10.7221 4.22552 11.1009Z",
    fill: "#D67568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71432 25.2051H5.85718L5.85718 37.3405H8.71432L8.71432 25.2051Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11715 27.6543H6.4892L6.4892 34.7089H8.11715L8.11715 27.6543Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11715 27.6543H6.4892V27.8005H8.11715V27.6543Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11715 34.5996H6.4892V34.7458H8.11715V34.5996Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11715 32.2959H6.4892V32.4421H8.11715V32.2959Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11715 29.957H6.4892V30.1032H8.11715V29.957Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32797 28.3525C7.43594 28.3525 7.52167 28.3889 7.58515 28.4617C7.64918 28.5338 7.68119 28.6301 7.68119 28.7508C7.68119 28.8427 7.65731 28.9422 7.60957 29.0494C7.56236 29.1566 7.47908 29.2986 7.35971 29.4754H7.74955V29.7071H7.013V29.6793C7.09873 29.5549 7.17225 29.4432 7.23356 29.3443C7.29541 29.2447 7.34316 29.1624 7.3768 29.0973C7.41044 29.0316 7.43431 28.9757 7.44842 28.9298C7.46253 28.8838 7.46958 28.8363 7.46958 28.7871C7.46958 28.7259 7.45276 28.6745 7.41912 28.633C7.38602 28.5909 7.3456 28.5698 7.29785 28.5698C7.21213 28.5698 7.12314 28.6273 7.03091 28.7421V28.4799C7.12803 28.395 7.22705 28.3525 7.32797 28.3525Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38657 30.6426C7.50159 30.6426 7.59275 30.7035 7.66003 30.8254C7.72785 30.9473 7.76176 31.1139 7.76176 31.3251C7.76176 31.5383 7.72839 31.7064 7.66165 31.8296C7.59492 31.9528 7.50376 32.0143 7.38819 32.0143C7.271 32.0143 7.17822 31.9534 7.10985 31.8315C7.04203 31.709 7.00812 31.5414 7.00812 31.3289C7.00812 31.1171 7.04203 30.9499 7.10985 30.8273C7.17767 30.7042 7.26991 30.6426 7.38657 30.6426ZM7.21972 31.3366C7.21972 31.6423 7.27534 31.7951 7.38657 31.7951C7.49508 31.7951 7.54934 31.6343 7.54934 31.3127C7.54934 31.0121 7.49454 30.8618 7.38494 30.8618C7.27479 30.8618 7.21972 31.0201 7.21972 31.3366Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38864 32.9209C7.50367 32.9209 7.59482 32.9818 7.6621 33.1037C7.72992 33.2256 7.76384 33.3922 7.76384 33.6034C7.76384 33.8166 7.73047 33.9847 7.66373 34.1079C7.59699 34.2311 7.50584 34.2927 7.39027 34.2927C7.27307 34.2927 7.18029 34.2317 7.11193 34.1098C7.0441 33.9873 7.01019 33.8198 7.01019 33.6073C7.01019 33.3954 7.0441 33.2282 7.11193 33.1057C7.17975 32.9825 7.27199 32.9209 7.38864 32.9209ZM7.2218 33.6149C7.2218 33.9206 7.27741 34.0735 7.38864 34.0735C7.49716 34.0735 7.55142 33.9126 7.55142 33.591C7.55142 33.2904 7.49662 33.1401 7.38701 33.1401C7.27687 33.1401 7.2218 33.2984 7.2218 33.6149Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6647 11.7423V15.647C10.6647 15.9675 10.4443 16.2006 10.1504 16.1423C9.88109 16.0841 9.58725 16.0549 9.26892 15.9966V11.043C9.66071 11.2178 9.88109 11.3635 10.2239 11.5383C10.4933 11.6258 10.4933 11.6258 10.6647 11.7423Z",
    fill: "#D67568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90613 11.7433L3.90613 15.6479C3.90613 15.9685 4.12651 16.2016 4.42035 16.1433C4.6897 16.085 4.98354 16.0559 5.30186 15.9976L5.30186 11.0439C4.91008 11.2188 4.6897 11.3645 4.34689 11.5393C4.07753 11.6267 4.07753 11.6267 3.90613 11.7433Z",
    fill: "#D67568"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 14.5714,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.57143,
    height: 110,
    fill: "white",
    transform: "translate(3 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.14286,
    height: 10.4348,
    fill: "white",
    transform: "translate(3.71429 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2Micropipette);
export default __webpack_public_path__ + "static/media/P2_Micropipette.7463058803019f29f6e1b7120d62d5f0.svg";
export { ForwardRef as ReactComponent };